import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Button from "../Shared/Button";
import {
  getPractitionerEmailNotificationConfigs,
  updatePractitionerEmailNotificationConfigs,
} from "../../services/practitioner";
import { selectActivePractitioners } from "../appSlice";

const PractitionerEmailNotificationConfig = () => {
  const practitioners = useSelector(selectActivePractitioners);
  const [configChanged, setConfigChanged] = useState(false);
  const [isUpdatingConfig, setIsUpdatingConfig] = useState(false);
  const [emailNotificationConfigs, setEmailNotificationConfigs] = useState({});

  useEffect(() => {
    setEmailNotificationConfigs(
      practitioners.reduce(
        (acc, practitioner) => ({
          ...acc,
          [practitioner.practitionerId]: false,
        }),
        {}
      )
    );
    getPractitionerEmailNotificationConfigs().then(({ result, error }) =>
      setEmailNotificationConfigs((configs) => ({
        ...configs,
        ...result,
      }))
    );
  }, [practitioners]);

  const handleUpdateEmailNotificationConfig = ({ practitionerId, needsToRecieveEmail }) => {
    setConfigChanged(true);
    setEmailNotificationConfigs({
      ...emailNotificationConfigs,
      [practitionerId]: needsToRecieveEmail,
    });
  };

  const handleSubmit = async (e) => {
    setIsUpdatingConfig(true);
    try {
      await updatePractitionerEmailNotificationConfigs(
        Object.entries(emailNotificationConfigs)
          .filter((config) => config[1])
          .reduce(
            (acc, config) => ({
              ...acc,
              [config[0]]: config[1],
            }),
            {}
          )
      );
      setConfigChanged(false);
      setIsUpdatingConfig(false);
    } catch {
      setIsUpdatingConfig(false);
    }
  };

  return (
    <>
      <p className="menu-label">Practitioner Email Notification Config</p>
      <div className="columns is-mobile is-size-7">
        <div className="column is-half">
          <div className="table-container apt-table">
            <table className="table is-fullwidth is-stripe is-hoverable is-scrollable is-size-7">
              <tbody>
                <tr>
                  <td>Name</td>
                  <td>Need to recieve email</td>
                </tr>
                {practitioners.map((practitioner) => (
                  <tr key={practitioner.practitionerId}>
                    <td>
                      {practitioner.firstName} {practitioner.lastName}
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        checked={emailNotificationConfigs[practitioner.practitionerId] || false}
                        onChange={(e) =>
                          handleUpdateEmailNotificationConfig({
                            practitionerId: practitioner.practitionerId,
                            needsToRecieveEmail: e.target.checked,
                            setConfigChanged,
                          })
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Button text="SUBMIT" onClick={handleSubmit} isLoading={isUpdatingConfig} disabled={!configChanged} />
          </div>
        </div>
      </div>
    </>
  );
};

export default PractitionerEmailNotificationConfig;
